<template>
  <div class="box" v-if="detail.orderId">
    <div class="order-box">
      <div class="img">
        <img :src="imageView(detail.photoA, 204, 275)" />
        <div class="mian">共{{ detail.photoB ? '2' : '1' }}面</div>
      </div>
      <div class="info">
        <div class="name">{{ getName(detail.templateId) }}</div>
        <div class="type">{{ detail.cardType }}</div>
        <div class="type">{{ detail.userMobile }}</div>
      </div>
      <div class="price-box">
        <div class="price">{{ (detail.userPayment / 100).toFixed(2) }}</div>
      </div>
    </div>
    <div class="info">
      <div class="title">交易信息</div>
      <div class="form">
        <div class="item">
          <div>下单人信息：</div>
          <div>{{ detail.userMobile }} / {{ detail.userName }}</div>
        </div>
        <div class="item">
          <div>订单状态：</div>
          <div>{{ getStatus(detail.orderStatus, detail.refundApplyStatus) }}</div>
        </div>
        <div class="item">
          <div>付款时间：</div>
          <div>{{ formatDate(detail.paymentTime, '{y}-{m}-{d} {h}:{i}') }}</div>
        </div>
      </div>
      <div class="buttom"
        v-if="(detail.orderStatus === 1 && (detail.refundApplyStatus === -2 || detail.refundApplyStatus === -1))">
        <div class="but" @click="show = true">发起退款</div>
      </div>
    </div>
    <div class="info" v-if="detail.physical.id">
      <div class="title">实体卡信息</div>
      <div class="form">
        <div class="item">
          <div>数量：</div>
          <div>{{ detail.physical.amount ? detail.physical.amount : '0' }}</div>
        </div>
        <div class="item">
          <div>收件人信息：</div>
          <div>{{ detail.physical.deliveryAddress }}</div>
        </div>
        <div class="item" v-if="detail.physical.makingStatus === 0">
          <div>制卡状态：</div>
          <div>制作中</div>
        </div>
        <div class="item" v-else>
          <div>制卡订单：</div>
          <div>{{ detail.physical.makingOrderId }}</div>
        </div>
        <div class="item" v-if="detail.physical.logisticsStatus === 1">
          <div>物流单号：</div>
          <div>{{ detail.physical.logisticsWaybill }}</div>
        </div>
        <div class="item" v-else>
          <div>物流单号：</div>
          <div>未发货</div>
        </div>
      </div>
    </div>
    <div class="info" v-if="detail.nftA.id || detail.nftB.id">
      <div class="title">NFL信息</div>
      <div class="form">
        <div class="item" v-if="detail.nftA.id">
          <div>A面数量：</div>
          <div>{{ detail.nftA.amount }}</div>
        </div>
        <div class="item" v-if="detail.nftB.id">
          <div>B面数量：</div>
          <div>{{ detail.nftB.amount }}</div>
        </div>
      </div>
    </div>
    <van-popup v-model="show" round position="bottom" :style="{ height: '40%' }">
      <div class="popup">
        <div class="title">申请退款</div>
        <van-field v-model="message" rows="3" autosize label="退款理由" type="textarea" placeholder="请输入退款理由" />
        <div class="but">
          <div @click="refund">申请退款</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getPlayerCardOrderDetail, createPlayerCardOrderRefundApply } from '@/api/match'
import { QNImageUtil, DateUtil } from "@/utils";
import { playerList, matchCardList } from '@/utils/player-data'
import Vue from 'vue';
import { Popup, Field, Toast } from 'vant';
Vue.use(Popup).use(Field).use(Toast);
export default {
  data() {
    return {
      orderId: '',
      message: '',
      detail: {},
      playerCardList: [...playerList, ...matchCardList],
      show: false
    };
  },
  mounted() {
    // AdminGetPlayerCardOrderDetail
    this.orderId = this.$route.query.id
    this.getPlayerCardOrderDetail()
  },
  methods: {
    getPlayerCardOrderDetail() {
      getPlayerCardOrderDetail({ orderId: this.orderId }).then(res => {
        this.detail = res.data.detail
      })
    },
    imageView(img, w, h) {
      return QNImageUtil.imageView(img, w, h)
    },
    getName(id) {
      const obj = this.playerCardList.find(item => item.id == id)
      return obj?.model || 'xxx'
    },
    getStatus(statu, refundApplyStatus) {
      if (statu === 1) {
        if (refundApplyStatus === -2) return '已支付'
        if (refundApplyStatus === 0) return '退款-待审核'
        if (refundApplyStatus === -1) return '拒绝'
        if (refundApplyStatus === 1) return '同意'
      } else if (statu === 2) {
        return '退款中'
      } else if (statu === 3) {
        return '已退款'
      }
    },
    formatDate(date, type) {
      if (!date) return ''
      return DateUtil.parseDateTime(date, type)
    },
    refund() {
      if (!this.message) return Toast('请输入退款理由')
      createPlayerCardOrderRefundApply({ orderId: this.orderId, remark: this.message, fee: this.detail.userPayment }).then(res => {
        console.log(res);
        if (res) {
          Toast('申请成功！')
          this.getPlayerCardOrderDetail()
          this.show = false
        }
      })
    }
  },
};
</script>

<style scoped lang="scss">
.box {
  min-height: 100vh;
  background-color: #F9F9F9;

  .order-box {
    padding: 12px;
    display: flex;
    background-color: #fff;
    margin-bottom: 6px;

    .img {
      margin-right: 12px;
      background: #F5F5F5;
      width: 80px;

      img {
        width: 100%;
      }

      .mian {
        text-align: center;
        background: #fff;
        font-size: 12px;
        padding-top: 4px;
      }
    }

    .info {
      flex: 1;

      .name {
        margin-bottom: 4px;
        margin-top: 6px;
        font-size: 15px;
      }

      .type {
        color: #a7a7a7;
        margin-top: 10px;
        font-size: 12px;
      }
    }

    .price-box {
      height: 130px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .price {
        margin-bottom: 4px;
        margin-top: 6px;
        font-size: 15px;
        color: #a7a7a7;
        text-align: right;
      }

      .but {
        color: #fff;
        background: #002FA7;
        font-size: 14px;
        border-radius: 16px;
        padding: 6px 12px;
      }
    }

  }

  .info {
    padding: 12px;
    background-color: #fff;
    margin-bottom: 6px;

    .title {
      font-size: 14px;
    }

    .form {
      color: #939393;

      .item {
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        margin-top: 6px;
        padding: 0 6px;
      }
    }

    .buttom {
      display: flex;
      justify-content: flex-end;
      margin-top: 12px;
    }

    .but {
      color: #fff;
      background: #002FA7;
      font-size: 14px;
      border-radius: 16px;
      padding: 4px 16px;
    }
  }

  .popup {
    position: relative;
    height: 100%;

    .title {
      text-align: center;
      font-weight: 500;
      padding: 12px 0;
    }

    .but {
      position: absolute;
      bottom: 0px;
      width: 100%;
      display: flex;
      justify-content: center;
      padding-bottom: 24px;

      div {
        width: 90%;
        background: #002FA7;
        color: #fff;
        padding: 12px 0;
        text-align: center;
        border-radius: 12px;
      }
    }

    ::v-deep .van-field__label {
      width: 65px;
    }

    ::v-deep .van-field__control {
      border: 1px solid #E4E7ED !important;
      border-radius: 8px;
      padding: 6px;
    }
  }
}
</style>
